import { array, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';
import { Id as ClientId } from '../../client';

export const Client = struct({
	equalsType: EqualsType,
	values: array(ClientId),
});
